import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {CustomText} from '@buncha/components/core/text';
import {HBox} from '@buncha/components/core/view';
import React from 'react';
import RightTickIcon from '@buncha/components/core/icon/RightTickIcon';
import {scaleFonts} from '@buncha/appStyles/style/font';
import {styles} from './styles';

interface SuccessItemCellFooterProps {
  title: string;
  rightComponent?: React.ReactNode;
}

const SuccessItemCellFooter: React.FC<SuccessItemCellFooterProps> = props => {
  const {title, rightComponent} = props;

  const theme = useColorThemeType();
  const muliFont = useFontTheme('muli');
  return (
    <HBox
      style={[
        styles.container,
        {
          borderColor: theme?.background.green[100],
        },
      ]}>
      <HBox style={styles.subContainer}>
        <RightTickIcon
          width={scaleFonts(14)}
          height={scaleFonts(14)}
          viewBox="0 0 20 20"
          fill={theme?.background.green[100]}
        />
        <CustomText
          style={[
            styles.textAlign,
            styles.titleStyle,
            {
              fontFamily: muliFont[700].normal,
              color: theme?.text.green[100],
            },
          ]}>
          {title}
        </CustomText>
      </HBox>
      {rightComponent}
    </HBox>
  );
};

export default React.memo(SuccessItemCellFooter);
